import { typedAction } from "../actionTypes";
import { checkoffer } from "../offers/offferModels";
import { OrderDetail } from "../order/orderModels";
import { STORE_MENU_ITEM } from "../restaurant/restaurantContants";
import {
  RestaurantDetail,
  RestaurantMenuItem,
  Tax,
} from "../restaurant/restaurantModels";
import {
  ADD_CUSTOMISE_INDIVIDUALLY,
  SAVE_ITEM_COMMENTS,
  REMOVE_CUSTOMISE_INDIVIDUALLY,
  ADD_CART_ITEM,
  REMOVE_CART_ITEM,
  PLACE_ORDER_FAILURE,
  PLACE_ORDER_REQUEST,
  PLACE_ORDER_SUCCESS,
  MODIFY_CART_ITEM,
  INCREMENT_CART_ITEM,
  DECREMENT_CART_ITEM,
  REMOVE_LAST_ITEM_INSTANCE,
  SAVE_ITEM_CUSTOMISATION,
  START_CUSTOMISE_ITEM,
  FINISH_ITEM_CUSTOMISATION,
  SAVE_ORDER_DETAILS,
  CLEAR_PLACE_ORDER,
  SHOW_FLOATING_CART,
  HIDE_FLOATING_CART,
  REMOVE_CART_TIP,
  START_EMPTY_CART,
  SET_PICKUP_TIME,
  STORE_CART_RESTAURANT_DETAILS,
  SHOW_ITEM_MAX_COUNT_PROMPT,
  HIDE_ITEM_MAX_COUNT_PROMPT,
  LOAD_SAVED_INDIVIDUAL_CUSTOMISATION,
  CLEAR_PLACE_ORDER_SUCCESS,
  ADD_DELIVERY_ADDRESS,
  SET_CART_AUTH_PENDING,
  SET_GUEST_MOBILE_VERIFIED,
  SET_DELIVERY_ORDER_DISTANCE,
  CLEAR_DELIVERY_ORDER_DISTANCE,
  SET_RUNNING_CART,
  CLEAR_RUNNING_CART,
  UPDATE_CART_ITEM,
  RECONCILE_ITEM_OFFER,
  CLEAR_CUSTOMISE_ITEM,
  UPDATE_EVENT_ORDER,
  UPDATE_EVENT_ORDER_SLOT,
  TOTALS,
  REMOVE_CART_ITEM_ORDER_TYPE,
  SET_ORDER_TYPE,
  SPECIAL_NOTES,
  REMOVE_NOTES,
  CART_ITEM_REQUEST,
  CART_ITEM_SUCCESS,
  CART_ITEM_FAILURE,
  VALIDATE_BOGO_ITEM_REQUEST,
  VALIDATE_BOGO_ITEM_SUCCESS,
  VALIDATE_BOGO_ITEM_FAILURE,
  TOGGLE_CART_VIEW,
  SET_SELECTED_DATE,
  SET_ORDER_INSTRUCTIONS,
  CLEAR_PLACE_ORDER_STATUS,
  SET_IS_TIP_ADDEDD,
  REPLACE_CART_ITEMS,
  SET_SELECTED_TIME_SLOT,
  SET_DELIVERY_INSTRUCTIONS,
  RESET_CART,
  RESERVATION_MENU_API_CALL,
  RESET_RESERVATION_MENU_API_CALL,
  NO_TIP,
  CUSTOME_TIP,
  CLEAR_DELIVERY_INSTRUCTIONS,
  CUSTOME_TIP_VALUE,
  CLEAR_NO_TIP,
  CLEAR_CUSTOME_TIP,
  CLEAR_CUSTOME_TIP_VALUE,
  CUSTOMIZATION_POPUP,
  CHANGE_CALL_WAITER,
  SET_SELECTED_BUZZER,
  IS_SCHEDULER_ORDER_PLACE_ORDER,
  COUPON_CLICKED,
  CLEAR_TOTALS,
  ROUTE_TO_LOGIN,
  ASK_TO_LOGIN,
  CLEAR_PLACE_ORDER_LOADING,
  GET_CUSTOMER_OFFERS_REQUEST,
  GET_CUSTOMER_OFFERS_SUCCESS,
  GET_CUSTOMER_OFFERS_FAILURE,
  SET_TOTALS_CONFIRMED_OFFER_IDS,
  SET_ITEM_LEVEL_PROMO_CODE,
  POST_PAYMENT_LOYALTY_REQUEST,
  OPEN_TIP,
  CART_RECOMMENDATIONS_REQUEST,
  CART_RECOMMENDATIONS_SUCCESS,
  CART_RECOMMENDATIONS_FAILURE,
  FLUSH_CART_RECOMMENDATIONS,
  REC_CLICK_REQUEST,
  REC_CLICK_SUCCESS,
  REC_CLICK_FAILURE,
  REC_CONVERT_REQUEST,
  REC_CONVERT_SUCCESS,
  REC_CONVERT_FAILURE,
} from "./cartConstants";
import {
  CartItem,
  Cart,
  CartItemOption,
  CartSaveItem,
  CartInitRequest,
  CartLocationDetail,
  CartRecommendationsRequest,
  CartRecommendationsResponse,
  RecClickRequest,
  RecClickResponse,
  RecConvertRequest,
  RecConvertResponse,
} from "./cartModels";

// Item Actions
export function addCartItem(item: CartItem, pseudo: boolean = false) {
  return typedAction(ADD_CART_ITEM, { item: item, pseudo: pseudo });
}

export function removeCartItem(
  itemId: string,
  index: number = -1,
  pseudo: boolean = false
) {
  return typedAction(REMOVE_CART_ITEM, {
    itemId: itemId,
    index: index,
    pseudo: pseudo,
  });
}

export function removeCartItemOrderType() {
  return typedAction(REMOVE_CART_ITEM_ORDER_TYPE, {});
}

export function replacecartItems(payload: any) {
  return typedAction(REPLACE_CART_ITEMS,payload)
}

export function incrementCartItem(
  itemId: string,
  index: number = -1,
  pseudo: boolean = false
) {
  return typedAction(INCREMENT_CART_ITEM, {
    itemId: itemId,
    index: index,
    pseudo: pseudo,
  });
}
// export function updateCartItem(
//   itemId:string,
//   quantity:number,
//   amount:string,
// ){
//   return typedAction(UPDATE_CART_ITEM, {
//     itemId:itemId,
//     quantity:quantity,
//     amount:amount,
//   });
// }

export function updateCartItem(
  itemId: string,
  amount: string,
  is_discount_applied: boolean = false,
  quantity?: number,
  old_quantity?: number,
  offer_data?: checkoffer,
  pseudo: boolean = false,
  index: number = -1,
  stockQuantity?: number | null,
  alertQuantity?: number | null,
  options?: any,
  modifierIds?: any
  // offer_amount:number = 0,
) {
  return typedAction(UPDATE_CART_ITEM, {
    itemId: itemId,
    amount: amount,
    is_discount_applied: is_discount_applied,
    quantity: quantity ? quantity : 0,
    old_quantity: old_quantity,
    offer_data: offer_data,
    pseudo: pseudo,
    index: index,
    // offer_amount:offer_amount,
    stockQuantity: stockQuantity,
    alertQuantity: alertQuantity,
    options: options ? options : [],
    modifierIds: modifierIds ? modifierIds : "",
  });
}
// Reconcile a cart item's item-level offer state with the menu/customer
// state. Used by the global watcher to apply the offer on login or revert
// it on logout, without dropping other cart-item state (modifiers, etc).
export function reconcileItemOffer(payload: {
  itemId: string;
  // When provided, only the cart entry whose modifierIds matches this value
  // is updated. Required to avoid cross-contaminating two entries that share
  // the same itemId but carry different customizations (different modifier
  // prices → different effective unit prices → infinite oscillation).
  modifierIds?: string;
  apply: boolean;
  // When applying: target price/offerId from the menu item.
  // When reverting: regular price and clears offerId.
  price: string | number;
  offerId?: string | number | null;
  // Optional pre-computed line subTotal. The watcher passes this when the
  // item-level offer carries a maxDiscountCap so the per-line discount is
  // clamped (it can't be expressed as qty × price). When omitted the reducer
  // falls back to qty × (price + modifiers).
  subTotal?: string | number;
  // Regular (pre-discount) unit price — always the menu item's current
  // price, whether applying or reverting. Kept separate from `price` so the
  // order payload can carry both to the backend.
  originalPrice?: string | number;
}) {
  return typedAction(RECONCILE_ITEM_OFFER, payload);
}

export function decrementCartItem(
  itemId: string,
  index: number = -1,
  pseudo: boolean = false
) {
  return typedAction(DECREMENT_CART_ITEM, {
    itemId: itemId,
    index: index,
    pseudo: pseudo,
  });
}

export function saveItemComments(itemId: string, comment: string) {
  return typedAction(SAVE_ITEM_COMMENTS, { itemId: itemId, comment: comment });
}

// Customisation Actions
export function startItemCustomisation(itemDetail: CartItem[]) {
  return typedAction(START_CUSTOMISE_ITEM, itemDetail);
}

export function addCustomiseIndividually(itemId: string) {
  return typedAction(ADD_CUSTOMISE_INDIVIDUALLY, itemId);
}

export function removeCustomiseIndividually(itemId: string) {
  return typedAction(REMOVE_CUSTOMISE_INDIVIDUALLY, itemId);
}

export function loadSavedCustomisation(itemId: string) {
  return typedAction(LOAD_SAVED_INDIVIDUAL_CUSTOMISATION, itemId);
}

export function removeLastItemInstance(itemId: string) {
  return typedAction(REMOVE_LAST_ITEM_INSTANCE, itemId);
}

export function saveItemCustomisation(item: CartSaveItem) {
  return typedAction(SAVE_ITEM_CUSTOMISATION, item);
}

export function finishCustomisation(itemId: string) {
  return typedAction(FINISH_ITEM_CUSTOMISATION, itemId);
}

// export function modifyCartItem(itemDetails: ModifyCartItemDetails) {
//   return typedAction(MODIFY_CART_ITEM, itemDetails);
// }

// Place Order
export function saveOrderDetails(data: {
  tipValue?: number;
  tipType?: "PERCENT" | "FLATFEE" | "";
  orderNote?: string;
}) {
  return typedAction(SAVE_ORDER_DETAILS, {
    tipValue: data.tipValue,
    orderNote: data.orderNote,
    tipType: data.tipType,
  });
}

export function removeCartTip() {
  return typedAction(REMOVE_CART_TIP, "");
}

export function placeOrder(
  details: Cart,
  allStorage: any,
  cookies: any,
  orderApiType?: "DEFAULT" | "DINE_IN"
) {
  return typedAction(PLACE_ORDER_REQUEST, { details, allStorage, cookies, orderApiType });
}

export function failedPlaceOrder(errorMessage: string) {
  return typedAction(PLACE_ORDER_FAILURE, errorMessage);
}
export function isScheduleOrderPlaceOrder(isScheduleOrder: boolean) {
  return typedAction(IS_SCHEDULER_ORDER_PLACE_ORDER, isScheduleOrder);
}
export function successPlaceOrder(orderId: string) {
  return typedAction(PLACE_ORDER_SUCCESS, { orderId: orderId });
}

export function completePlaceOrder() {
  return typedAction(CLEAR_PLACE_ORDER_SUCCESS, "");
}

export function clearPlaceOrder() {
  return typedAction(CLEAR_PLACE_ORDER, "");
}

export function showFloatingCart() {
  return typedAction(SHOW_FLOATING_CART, "");
}

export function hideFloatingCart() {
  return typedAction(HIDE_FLOATING_CART, "");
}

export function startEmptyCart(data: CartInitRequest) {
  return typedAction(START_EMPTY_CART, data);
}

export function setPickupTime(
  time: string,
  date: string,
  isASAP: boolean,
  isEventDate?: boolean
) {
  return typedAction(SET_PICKUP_TIME, {
    time: time,
    date: date,
    isASAP: isASAP,
    isEventDate: isEventDate,
  });
}

export function storeCartRestaurantDetails(
  restaurantDetails: RestaurantDetail,
  restaurantOrderTax: Tax[],
  restaurantDefaultTax: Tax[]
) {
  return typedAction(STORE_CART_RESTAURANT_DETAILS, {
    restaurantDetails: restaurantDetails,
    restaurantOrderTax: restaurantOrderTax,
    restaurantDefaultTax: restaurantDefaultTax,
  });
}

export function showItemMaxCountPrompt() {
  return typedAction(SHOW_ITEM_MAX_COUNT_PROMPT, "");
}

export function hideItemMaxCountPrompt() {
  return typedAction(HIDE_ITEM_MAX_COUNT_PROMPT, "");
}

export function storeMenuItem(item: RestaurantMenuItem) {
  return typedAction(STORE_MENU_ITEM, item);
}

export function addDeliveryAddress(deliveryAddress: CartLocationDetail) {
  return typedAction(ADD_DELIVERY_ADDRESS, deliveryAddress);
}

export function setCartAuthPending(status: boolean, cartURL: string) {
  return typedAction(SET_CART_AUTH_PENDING, {
    status: status,
    cartURL: cartURL,
  });
}

export function setGuestMobileVerified(value: boolean) {
  return typedAction(SET_GUEST_MOBILE_VERIFIED, value);
}

export function setDeliveryOrderDistance(distance: number) {
  return typedAction(SET_DELIVERY_ORDER_DISTANCE, distance);
}

export function clearDeliveryOrderDistance() {
  return typedAction(CLEAR_DELIVERY_ORDER_DISTANCE, "");
}

export function setRunningCart(cart: Cart) {
  return typedAction(SET_RUNNING_CART, cart);
}

export function clearRunningCart() {
  return typedAction(CLEAR_RUNNING_CART, "");
}

export function clearCutomizationItem() {
  return typedAction(CLEAR_CUSTOMISE_ITEM, "");
}

export function setEventOrder(
  isEventOrder: boolean,
  eventDate: string | undefined
) {  
  return typedAction(UPDATE_EVENT_ORDER, { isEventOrder, eventDate });
}

export function setEventOrderSlotTime(eventSlot: string) {
  return typedAction(UPDATE_EVENT_ORDER_SLOT, { eventSlot });
}

export function setTotals(data: any) {
  return typedAction(TOTALS, data);
}

export function setTotalsConfirmedOfferIds(ids: string[]) {
  return typedAction(SET_TOTALS_CONFIRMED_OFFER_IDS, ids);
}

export function setSelectedOrderType(data: any) {
  return typedAction(SET_ORDER_TYPE, data);
}

export function specialNotes(
  itemId?: any,
  index: number = -1,
  pseudo: boolean = false,
  orderNote?: any
) {
  return typedAction(SPECIAL_NOTES, {
    itemId: itemId,
    index: index,
    pseudo: pseudo,
    orderNote: orderNote,
  });
}

export function removeNotes(
  itemId?: any,
  index: number = -1,
  pseudo: boolean = false
) {
  return typedAction(REMOVE_NOTES, {
    itemId: itemId,
    index: index,
    pseudo: pseudo,
  });
}

export function cartItemRequest(data: any){
  return typedAction(CART_ITEM_REQUEST, data)
}

export function cartItemSuccess(data: any){
  return typedAction(CART_ITEM_SUCCESS, data)
}

export function cartItemFailure(data: any){
  return typedAction(CART_ITEM_FAILURE, data)
}

export function validateBogoItemRequest(data: { itemId: string; locationId: string; customerId: string }) {
  return typedAction(VALIDATE_BOGO_ITEM_REQUEST, data)
}

export function validateBogoItemSuccess(data: any) {
  return typedAction(VALIDATE_BOGO_ITEM_SUCCESS, data)
}

export function validateBogoItemFailure(data: any) {
  return typedAction(VALIDATE_BOGO_ITEM_FAILURE, data)
}

export function toggleCartView(data: boolean) {
  return typedAction(TOGGLE_CART_VIEW, data);
}

export function setSelectedDate(date: any) {
  return typedAction(SET_SELECTED_DATE, date);
}
export function setSelectedTimeSlot(data: string) {
  return typedAction(SET_SELECTED_TIME_SLOT, data);
}

export function setOrderInstructions(instructions: string) {
  return typedAction(SET_ORDER_INSTRUCTIONS, instructions);
}

export function setDeliveryInstructions(instructions: string) {
  return typedAction(SET_DELIVERY_INSTRUCTIONS, instructions);
}

export function clearDeliveryInstruction(){
  return typedAction(CLEAR_DELIVERY_INSTRUCTIONS)
}
export function clearNotip(){
  return typedAction(CLEAR_NO_TIP)
}
export function clearCustomtip(){
  return typedAction(CLEAR_CUSTOME_TIP)
}
export function clearCustomTipvalue(){
  return typedAction(CLEAR_CUSTOME_TIP_VALUE)
}

export function clearPlaceOrderStatus(){
  return typedAction(CLEAR_PLACE_ORDER_STATUS)
}
export function clearPlaceOrderLoading(){
  return typedAction(CLEAR_PLACE_ORDER_LOADING)
}

export function requestPostPaymentLoyalty(orderId: string, locationId: string) {
  return typedAction(POST_PAYMENT_LOYALTY_REQUEST, { orderId, locationId });
}
export function setTipAdded(data:boolean){
  return typedAction(SET_IS_TIP_ADDEDD,data)
}

export function setNotip(data:string){
  return typedAction(NO_TIP,data)
}

export function setCustomTip(data:boolean){
  return typedAction(CUSTOME_TIP,data)
}

export function setCustomTipValue(data:string){
  return typedAction(CUSTOME_TIP_VALUE,data)
}

export function resetCart(){
  return typedAction(RESET_CART)
}

export function reservatonMenuApiCall(){
  return typedAction(RESERVATION_MENU_API_CALL)
}

export function resetReservationMenuApiCall(){
  return typedAction(RESET_RESERVATION_MENU_API_CALL)
}

export function customizationPopUp(data: boolean){
  return typedAction(CUSTOMIZATION_POPUP, data)
}

export function changeCallWaiter(data: string){
  return typedAction(CHANGE_CALL_WAITER, data)
}

export function setSelectedBuzzer(data: number | null){
  return typedAction(SET_SELECTED_BUZZER, data)
}

export function couponClicked(data:boolean){
  return typedAction(COUPON_CLICKED,data)
}

export function clearTotals(){
  return typedAction(CLEAR_TOTALS)
}

export function routeToLogin(data: boolean){
  return typedAction(ROUTE_TO_LOGIN, data)
}

export function askToLogin(data: boolean){
  return typedAction(ASK_TO_LOGIN, data)
}

export function setItemLevelPromoCode(data: { offerId: string; promoCode: string }) {
  return typedAction(SET_ITEM_LEVEL_PROMO_CODE, data);
}

export function getCustomerOffersRequest(data: { locationId: string }) {
  return typedAction(GET_CUSTOMER_OFFERS_REQUEST, data);
}

export function getCustomerOffersSuccess(data: any[]) {
  return typedAction(GET_CUSTOMER_OFFERS_SUCCESS, data);
}

export function getCustomerOffersFailure(error: any) {
  return typedAction(GET_CUSTOMER_OFFERS_FAILURE, error);
}

export function openTip(data: boolean){
  return typedAction(OPEN_TIP, data)
}

export function fetchCartRecommendations(payload: CartRecommendationsRequest) {
  return typedAction(CART_RECOMMENDATIONS_REQUEST, payload);
}

export function fetchCartRecommendationsSuccess(data: CartRecommendationsResponse) {
  return typedAction(CART_RECOMMENDATIONS_SUCCESS, data);
}

export function fetchCartRecommendationsFailure(error: string) {
  return typedAction(CART_RECOMMENDATIONS_FAILURE, error);
}

export function flushCartRecommendations() {
  return typedAction(FLUSH_CART_RECOMMENDATIONS, "");
}

export function recClick(payload: RecClickRequest) {
  return typedAction(REC_CLICK_REQUEST, payload);
}

export function recClickSuccess(data: RecClickResponse) {
  return typedAction(REC_CLICK_SUCCESS, data);
}

export function recClickFailure(error: string) {
  return typedAction(REC_CLICK_FAILURE, error);
}

export function recConvert(payload: RecConvertRequest) {
  return typedAction(REC_CONVERT_REQUEST, payload);
}
export function recConvertSuccess(data: RecConvertResponse) {
  return typedAction(REC_CONVERT_SUCCESS, data);
}
export function recConvertFailure(error: string) {
  return typedAction(REC_CONVERT_FAILURE, error);
}

export type CartActions = ReturnType<
  | typeof addCartItem
  | typeof removeCartItem
  | typeof placeOrder
  | typeof failedPlaceOrder
  | typeof isScheduleOrderPlaceOrder
  | typeof successPlaceOrder
  | typeof completePlaceOrder
  | typeof incrementCartItem
  | typeof decrementCartItem
  | typeof addCustomiseIndividually
  | typeof removeCustomiseIndividually
  | typeof loadSavedCustomisation
  | typeof removeLastItemInstance
  | typeof saveItemCustomisation
  | typeof startItemCustomisation
  | typeof finishCustomisation
  | typeof saveItemComments
  | typeof saveOrderDetails
  | typeof clearPlaceOrder
  | typeof removeCartTip
  | typeof showFloatingCart
  | typeof hideFloatingCart
  | typeof startEmptyCart
  | typeof setPickupTime
  | typeof storeCartRestaurantDetails
  | typeof showItemMaxCountPrompt
  | typeof hideItemMaxCountPrompt
  | typeof storeMenuItem
  | typeof addDeliveryAddress
  | typeof setCartAuthPending
  | typeof setGuestMobileVerified
  | typeof setDeliveryOrderDistance
  | typeof clearDeliveryOrderDistance
  | typeof setRunningCart
  | typeof clearRunningCart
  | typeof updateCartItem
  | typeof reconcileItemOffer
  | typeof clearCutomizationItem
  | typeof setEventOrder
  | typeof setEventOrderSlotTime
  | typeof setTotals
  | typeof removeCartItemOrderType
  | typeof setSelectedOrderType
  | typeof specialNotes
  | typeof removeNotes
  | typeof cartItemRequest
  | typeof cartItemSuccess
  | typeof cartItemFailure
  | typeof toggleCartView
  | typeof setSelectedDate
  | typeof setSelectedTimeSlot
  | typeof setOrderInstructions
  | typeof clearPlaceOrderStatus
  | typeof setTipAdded
  | typeof replacecartItems
  | typeof setDeliveryInstructions
  | typeof resetCart
  | typeof reservatonMenuApiCall
  | typeof resetReservationMenuApiCall
  | typeof setNotip
  | typeof setCustomTip
  | typeof clearDeliveryInstruction
  | typeof setCustomTipValue
  | typeof clearNotip
  | typeof clearCustomtip
  | typeof clearCustomTipvalue
  | typeof customizationPopUp
  | typeof changeCallWaiter
  | typeof setSelectedBuzzer
  | typeof couponClicked
  | typeof clearTotals
  | typeof routeToLogin
  | typeof askToLogin
  | typeof clearPlaceOrderLoading
  | typeof getCustomerOffersRequest
  | typeof getCustomerOffersSuccess
  | typeof getCustomerOffersFailure
  | typeof setTotalsConfirmedOfferIds
  | typeof setItemLevelPromoCode
  | typeof validateBogoItemRequest
  | typeof validateBogoItemSuccess
  | typeof validateBogoItemFailure
  | typeof openTip
  | typeof fetchCartRecommendations
  | typeof fetchCartRecommendationsSuccess
  | typeof fetchCartRecommendationsFailure
  | typeof flushCartRecommendations
  | typeof recClick
  | typeof recClickSuccess
  | typeof recClickFailure
  | typeof recConvert
  | typeof recConvertSuccess
  | typeof recConvertFailure
  >;
